import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import './app/styles.css';

import { App } from './App.js';

const container = document.getElementById('root');
if (container === null) throw new Error('Root container #root is missing from index.html');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
